import React, { useMemo } from "react";
import ReactDOM from "react-dom";
import { useLightBox } from "../../../contexts/lightBoxContext/lightBoxContext.js";

import "./LightBoxManager.scss";

const LightBoxManager = ({ ignoreUrl }) => {
  const { getLightBox, getCondition } = useLightBox();
  const LightBox = getLightBox({ ignoreUrl });

  return useMemo(
    () =>
      LightBox ? ReactDOM.createPortal(<LightBox />, document.body) : null,
    [getCondition()]
  );
};

export default LightBoxManager;
